import { client } from '../http';

export default {
  async getCustomerPii() {
    const response = await client.get('/api/pii');
    return response.data;
  },
};
